import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-text-editor-header-person-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfTextEditorHeaderPersonIconProps extends SvgIconProps  {}

/**
 * THis iconis used to display header person icon
 * @param props -
 * @example
 * @returns
 */
export function CcfTextEditorHeaderPersonIcon(
  props: CcfTextEditorHeaderPersonIconProps
) {
  return (
    <SvgIcon
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.78975 9.51932C6.96667 9.51932 7.92075 8.56524 7.92075 7.38832C7.92075 6.21141 6.96667 5.25732 5.78975 5.25732C4.61283 5.25732 3.65875 6.21141 3.65875 7.38832C3.65875 8.56524 4.61283 9.51932 5.78975 9.51932Z"
        fill="#526B7A"
      />
      <path
        d="M2.10876 13.3563C2.10876 12.3803 2.49648 11.4443 3.18661 10.7541C3.87675 10.064 4.81277 9.67627 5.78876 9.67627C6.76476 9.67627 7.70078 10.064 8.39092 10.7541C9.08105 11.4443 9.46876 12.3803 9.46876 13.3563C8.29065 13.7872 7.04299 13.9963 5.78876 13.9733C4.53454 13.9964 3.28687 13.7872 2.10876 13.3563H2.10876Z"
        fill="#526B7A"
      />
      <path
        d="M12.7898 9.51932C13.9667 9.51932 14.9208 8.56524 14.9208 7.38832C14.9208 6.21141 13.9667 5.25732 12.7898 5.25732C11.6128 5.25732 10.6588 6.21141 10.6588 7.38832C10.6588 8.56524 11.6128 9.51932 12.7898 9.51932Z"
        fill="#526B7A"
      />
      <path
        d="M9.10876 13.3563C9.10876 12.3803 9.49648 11.4443 10.1866 10.7541C10.8767 10.064 11.8128 9.67627 12.7888 9.67627C13.7648 9.67627 14.7008 10.064 15.3909 10.7541C16.0811 11.4443 16.4688 12.3803 16.4688 13.3563C15.2907 13.7872 14.043 13.9963 12.7888 13.9733C11.5345 13.9964 10.2869 13.7872 9.10876 13.3563H9.10876Z"
        fill="#526B7A"
      />
      <path
        d="M9.16578 10.9852C10.6459 10.9852 11.8458 9.78537 11.8458 8.30524C11.8458 6.82512 10.6459 5.62524 9.16578 5.62524C7.68566 5.62524 6.48578 6.82512 6.48578 8.30524C6.48578 9.78537 7.68566 10.9852 9.16578 10.9852Z"
        fill="#526B7A"
      />
      <path
        d="M9.16578 10.7352C10.5078 10.7352 11.5958 9.6473 11.5958 8.30524C11.5958 6.96319 10.5078 5.87524 9.16578 5.87524C7.82373 5.87524 6.73578 6.96319 6.73578 8.30524C6.73578 9.6473 7.82373 10.7352 9.16578 10.7352Z"
        stroke="#F8FAFB"
        strokeWidth="0.5"
      />
      <path
        d="M9.15895 15.3681C7.75736 15.3681 6.43629 15.1594 5.41431 14.7786C5.52315 12.8102 7.16824 11.2363 9.15895 11.2363C11.1497 11.2363 12.7946 12.8103 12.9032 14.7787C11.8813 15.1595 10.5603 15.3681 9.15895 15.3681Z"
        fill="#526B7A"
      />
      <path
        d="M9.15894 15.1181C10.4512 15.1181 11.6705 14.9381 12.6385 14.6078C12.4483 12.8577 10.9543 11.4863 9.15894 11.4863C7.36359 11.4863 5.86945 12.8577 5.67906 14.6077C6.64713 14.9381 7.86646 15.1181 9.15894 15.1181ZM9.15894 15.6181C7.59902 15.6181 6.1859 15.3621 5.15875 14.9476C5.17978 12.7563 6.96263 10.9863 9.15894 10.9863C11.3554 10.9863 13.1379 12.7562 13.1588 14.9478C12.1316 15.3622 10.7187 15.6181 9.15894 15.6181Z"
        fill="#F8FAFB"
      />
    </SvgIcon>
  );
}

export default CcfTextEditorHeaderPersonIcon;
